import { render, staticRenderFns } from "./promoter-form.vue?vue&type=template&id=371a8bb8&"
import script from "./promoter-form.vue?vue&type=script&lang=js&"
export * from "./promoter-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports